import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import msSalService from '../../services/msSalService';
import { getItemCookie, isExpired, parseQueryString } from '../../utils/helpers';

function wait(ms) {
    const start = new Date().getTime();
    let end = start;
    while (end < start + ms) {
        end = new Date().getTime();
    }
}

class Jobboard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirecturl: undefined,
            signedIn: undefined,
        };
    }

    // eslint-disable-next-line react/no-deprecated
    componentWillMount() {
        const aJobboardSignedIN = localStorage.getItem('LocalStorage_JobboardSignedIN');
        const aIdtoken = getItemCookie('msal.idtoken');

        if (aIdtoken === null) {
            // Pause to see if timing is to quick
            wait(2000); // 2 seconds in milliseconds
            localStorage.setItem('LocalStorage_JobboardSignedIN', 'true');
            this.setPath();
            msSalService.signIn();
        } else if (isExpired() === true) {
            this.setState({
                redirecturl: encodeURI(
                    `${process.env.REACT_APP_LT_API_URI}/Resources/Security/LogoutApplication?url=${process.env.REACT_APP_LOGIN_URL}`
                ),
                signedIn: false,
            });
            msSalService.setNewRedirectUri();
            msSalService.logOut();
        } else if (aJobboardSignedIN === 'true' && aIdtoken !== null) {
            localStorage.setItem('LocalStorage_JobboardSignedIN', 'false');
            this.setState({
                redirecturl: localStorage.getItem('LocalStorage_JobboardSignedINPath'),
            });
        } else if (
            (aJobboardSignedIN === 'false' || aJobboardSignedIN === null) &&
            aIdtoken !== null
        ) {
            this.setPath();
            this.setState({
                redirecturl: localStorage.getItem('LocalStorage_JobboardSignedINPath'),
            });
        }
    }

    setPath = () => {
        const queryString = window.location.hash.split('?')[1];

        if (queryString !== undefined) {
            const parsedQueryString = parseQueryString(queryString);

            if (parsedQueryString.path !== undefined) {
                const queryPath = parsedQueryString.path.split('#')[1];

                localStorage.setItem('LocalStorage_JobboardSignedINPath', queryPath);
            }
        } else {
            localStorage.setItem('LocalStorage_JobboardSignedINPath', '/dashboard');
        }
    };

    render() {
        const { redirecturl, signedIn } = this.state;

        if (redirecturl) {
            if (signedIn === false) {
                return <div />;
            }
            return <Redirect to={redirecturl} />;
        }
        return <div />;
    }
}

export default Jobboard;
